module.exports = __webpack_public_path__ + "img/xiong.11afe8e0.png";